export default "__VITE_ASSET__CtYzIUW3__"